import React from "react";
import AdminLayerBlueprint from "components/blueprints/AdminLayerBlueprint";
import AdminSettingsOverview from "./AdminSettingsOverview";

function AdminSettingsPage() {
  return (
    <div className="min-h-screen bg-gray-100 py-2">
      <div className="container mx-auto my-6 flex">
        <section className="w-full">
          <AdminSettingsOverview />
        </section>
      </div>
    </div>
  )
}

export default AdminLayerBlueprint(AdminSettingsPage);
